import { headerStyles } from "@waytek/Overrides/Widgets/AccountSettings/AccountSettingsHeader";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

headerStyles.titleWrapper = {
    ...headerStyles.titleWrapper,
    css: css`
        &&& {
            padding: 35px 15px 40px;
        }
    `,
};

headerStyles.title = {
    ...headerStyles.title,
    as: "h1",
    size: 36,
    css: css`
        padding: 0;
        margin: 0;
    `,
};

headerStyles.buttonSet = {
    ...headerStyles.buttonSet,
    css: css`
        padding: 0 15px;
        align-items: center;
        justify-content: flex-end;

        ${mediaQueriesBP.maxMD} {
            padding: 0;
        }
    `,
};
